import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { delay, getErrorMessage } from '../../../../../../../../utils/helper';
import ModalConfirm from '../../../../../../../../components/Modal/ConfirmLayouts';
import Loader from '../../../../../../../../components/Loaders/Loader';
import { themesCopy } from '../../../../../../../../services/endpoints/themes';

const CopyModal = ({ data, onHide, onSubmit }) => {
  const [form, setForm] = useState({
    modalData: data,
    isLoading: false,
    error: null,
    success: false,
  });

  const { modalData, isLoading, error, success } = form;

  const onCopy = async () => {
    setForm((prevState) => ({
      ...prevState,
      isLoading: true,
    }))

    try {
      await themesCopy(modalData.id);
      setForm((prevState) => ({
        ...prevState,
        success: true,
      }))
      await delay(500);
      onSubmit();
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setForm((prevState) => ({
        ...prevState,
        isLoading: false,
        error: errorMessage,
      }))
    }
  }

  return (
    <ModalConfirm.Wrapper>
      <Modal.Body>
        <>
          <ModalConfirm.TitleDescriptionWrapper>
            {error ? <div className="alert alert-danger">{error}</div> : null}
            {isLoading ? <Loader success={success} /> : null }
            <ModalConfirm.Title>
              Copy theme
            </ModalConfirm.Title>
            <ModalConfirm.Description>
              <div>
                Are you sure you want to copy theme
                {' '}
                <b>{modalData?.name}</b>
                ?
              </div>
            </ModalConfirm.Description>
          </ModalConfirm.TitleDescriptionWrapper>
          <ModalConfirm.Actions>
            <Button
              type="submit"
              bsStyle="primary"
              disabled={isLoading}
              onClick={onCopy}
            >
              <span>Copy</span>
            </Button>
            <Button
              disabled={isLoading}
              onClick={onHide}
            >
              <span>Cancel</span>
            </Button>
          </ModalConfirm.Actions>
        </>
      </Modal.Body>
    </ModalConfirm.Wrapper>
  )
};

CopyModal.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default CopyModal;
